export default {
  header: {
    search: {
      placeholder: 'Rechercher...',
    },
    menu: {
      logout: 'Log out',
    },
  },

  sidebar: {
    menu: {
      dashboard: 'Dashboard',
      poi: 'Points of Interest',
      announcements: 'Announcements',
      media: 'Media Management',
      navigation: 'Navigation',
      pages: 'Pages',
      categories: 'Categories',
      footer: {
        switch: 'Switch Project',
        help: 'Get Help',
        logout: 'Log out',
      },
    },
  },

  toast: {
    welcome: 'Welcome Back, {user}',
    autologout: 'You are about to be logged out for inactivity.',
  },
}
